import React, { useState, useContext, useEffect } from "react";
import DriverSchemeForm from "../Forms/DriverSchemeForm";
import { DriverDeductionForm } from "../Forms/DriverDeductionForm";
import { DriverSchemeDeductionForm } from "../Forms/DriverSchemeDeductionForm";
import WalletMinBal from "../../WalletBalance/Forms/WalletMinBal";
import CustomTabs from "../../../CommonElements/CommonTabs/CustomTabs";
import TariffModal from "../../../CommonElements/TariffModal/TariffModal";
import SharedDataContext from "../../../_helper/SharedData";
import DriverSchemeConfigTable from "../View/DriverSchemeTable";
import { Breadcrumbs,Btn } from "../../../AbstractElements";
import { Plus } from "react-feather";
import { getAllDriverSchemeDeduction, searchSchemeDeductions } from "../../../Services/Driver.service";
import { showAlert } from "../../../Services/Shared.service";
import SearchTable from "../../Common/Component/SearchTable";

function DriverSchemeDeductionFlow() {

  const { globalCityField, setShowApiLoader,setTabValue} = useContext(SharedDataContext);
  const [isSearch, setIsSearch] = useState(true);
  const [isRefresh, setIsRefresh] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [driverSchemeTable,setDriverSchemeTable] = useState([])
  const [pagination, setPagination] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loader, setLoader] = useState(false);
  const [paginationTotalRows, setPaginationTotalRows] = useState(0);
  const [driverScheme, setDriverScheme] = useState();
  const [driverDeductionType, setDriverDeductionType] = useState();
  const [newDriverSchemeFlow, setNewDriverSchemeFlow] = useState(false);
  const [searchData, setSearchData] = useState("");
  const [filterType, setFilterType] = useState("");
  const [filterData, setFilterData] = useState([]);
  const [selectedServiceCityId, setSelectedServiceCityId] = useState(null);

  

  const onChangePage = (page) => {
    console.log("page", page);
    setPagination(page - 1);
  };

  const onChangeRowsPerPage = (currentRowsPerPage) => {
    setRowsPerPage(currentRowsPerPage);
  };

  const disableLoaders = () => {
    setLoader(false);
};

  const triggerRefresh = () => {
    setIsRefresh(!isRefresh);
  };
  useEffect(() => {
    fetchTableData();
}, [globalCityField.value, pagination, rowsPerPage,isRefresh,searchData]);

const handleBack=()=>{
  setIsSearch(true)
  setTabValue(prev=>prev-1)
}

const fetchTableData = () => {
  const serviceCityId = globalCityField.value?.id || 0;
      
      if(searchData && filterType == "search"){

        let obj = {
          key:searchData,
          serviceCityId: serviceCityId,
          page: pagination,
          size: rowsPerPage
        };

        setLoader(true)
        searchSchemeDeductions(obj).then((result)=>{
          setPaginationTotalRows(result.data.count);
          setDriverSchemeTable(result.data.searchResponse)
          disableLoaders();
        })
        
      }else{

        let obj = {
          isPagination: true,
          serviceCityId: serviceCityId,
          page: pagination,
          size: rowsPerPage,
        };
        
      setLoader(true);
      getAllDriverSchemeDeduction(obj)
          .then((result) => {
              setPaginationTotalRows(result.data.count);
              setDriverSchemeTable(result.data.searchResponse)
              disableLoaders();
          })
          .catch((err) => {
              disableLoaders();
              showAlert("error", err.response?.data?.message
                  ? err.response.data.message : "Something went wrong");
      });
    }
}
  const tabs = [
    {
      label: "Driver Scheme",
      content: (
        <DriverSchemeForm
          isSearch={isSearch}
          setIsSearch={setIsSearch}
          setDriverScheme={setDriverScheme}
          // driverTypeEditId={30}
          setNewDriverSchemeFlow={setNewDriverSchemeFlow}
          handleBack={handleBack}
        />
      ),
    },
    {
      label: "Deduction Type",
      content: (
        <DriverDeductionForm
          isSearch={isSearch}
          setIsSearch={setIsSearch}
          setDriverDeductionType={setDriverDeductionType}
          driverScheme={driverScheme}
          newDriverSchemeFlow={newDriverSchemeFlow}
          handleBack={handleBack}
        />
      ),
    },
    {
      label: "Deduction Value",
      content: (
        <DriverSchemeDeductionForm
          isSearch={isSearch}
          setIsSearch={setIsSearch}
         driverDeduction={driverDeductionType}
          driverScheme={driverScheme}
          handleBack={handleBack}
          setSelectedServiceCityId={setSelectedServiceCityId}
        />
      ),
    },
    {
      label: "Wallet Minimum Balance",
      content: <WalletMinBal isSearch={isSearch} setIsSearch={setIsSearch} driverScheme={driverScheme} triggerRefresh={triggerRefresh} handleBack={handleBack} selectedServiceCityId={selectedServiceCityId}/>,
    },
  ];

  const handleCloseModal = () => {
    if (!isSearch) {
      setIsSearch(true);
    } else {
      setIsModal(!isModal);
    }
  };

  return (
    <div>
      <Breadcrumbs
        parent="Configuration"
        subParent="Packages"
        mainTitle="Packages"
        span3={
          <SearchTable
            searchData={searchData}
            setSearchData={setSearchData}
            setFilterData={setFilterData}
            setFilterType={setFilterType}
            />
        }

        span1={
          <Btn
            attrBtn={{
              style: {
                display: "flex",
                padding: "7px 14px",
                justifyContent: "center",
                alignItems: "center",
              },
              onClick: (e) => setIsModal(true),
            }}
          >
            <Plus size={"18px"} style={{ marginRight: "5px" }} /> Add
          </Btn>
        }

      />

      {/* TableView for driver Scheme Deduction */}
      <DriverSchemeConfigTable
        isRefresh={isRefresh}
        driverSchemeTable={driverSchemeTable}
        triggerRefresh={triggerRefresh}
        onChangePage={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}
        paginationPerPage={rowsPerPage}
        paginationTotalRows={paginationTotalRows}
        loader={loader}
        setShowApiLoader={setLoader}
      />

      {/* <PackagesTable
       fetchTableData={fetchTableData}
       tableData={driverSchemeTable}
       setShowApiLoader={setLoader}
       onChangePage={onChangePage}
       paginationPerPage={rowsPerPage}
       paginationTotalRows={paginationTotalRows}
       onChangeRowsPerPage={onChangeRowsPerPage}
       onEditClick={onEditClick}
       loader={loader}
      /> */}

      {/* Driver Scheme Deduction */}
      <TariffModal
        isOpen={isModal}
        size="xl"
        centered
        toggler={handleCloseModal}
        title={"Driver Configurations"}
      >
        <CustomTabs tabs={tabs} />
      </TariffModal>
    </div>
  );
}

export default DriverSchemeDeductionFlow;
